<template>
  <div v-if="npsRating !== null" class="columns is-pulled-right nps-component">
    <div class="column is-1" :class="npsCat(npsRating)">
      {{ npsRating }}/10
    </div>
  </div>
</template>

<script>
import {misc} from '@/mixins'

export default {
  props: {
    npsRating: {
      type: Number,
      default: 0
    }
  },
  mixins: [misc]
}
</script>

<style scoped>
.detractors, .passives, .promoters {
  text-align: center;
  font-size: 14px;
  padding: 0;
  min-width: 100%;
  margin-top: 10px;
}

.detractors {
  color: red;
}

.passives {
  color: orange;
}

.promoters {
  color: green;
}

.nps-component {
  min-width: 110px;
  justify-content: center;
}

@media screen and (max-width: 767px) {
  .nps-component {
    min-width: 65px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NPSScore.vue